// extracted by mini-css-extract-plugin
export default {"error":"KeySwiftInput-module--error--ieMuu"};